import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "../assets/translations/Translations";

export const LOCALE_GERMAN = "de_DE";
export const LOCALE_ENGLISH = "en_US";

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: LOCALE_GERMAN,
    fallbackLng: LOCALE_GERMAN,
    debug: false,

    interpolation: {
      escapeValue: false,
    },
    resources: translations,
  });

export default i18n;
